module.exports =
  data: ->
    users_options: [value: null, text: @$t('general.feedback.loading')]

  methods:
    getUsersFromStore: ->
      # Busca os usuários no central store
      data = { users: @$store.getters.usersList }
      @loadUsersOptionsSuccess data

    loadUsersOptionsSuccess: (data) ->
      users_options = for user in data.users
        { value: {user_id_eq: user.id.toString()}, text: user.firstAndLastName() }
      users_options.unshift(value: null, text: @$t('general.label.user'))
      @users_options = users_options

      # Commita as mudanças para o state do central store
      @$store.commit 'loadUsers', data.users if @load_users

    loadUsersOptions: ->
      roles = [ User.ROLES['admin'], User.ROLES['seller'], User.ROLES['sdr'], User.ROLES['manager'] ]
      company_id = Session?.current_company?.id
      new UsersResource().index(@loadUsersOptionsSuccess, null, params: {q: {s: 'name asc', role_in: roles}, company_id: company_id})

  computed:
    load_users: ->
      @$store.getters.usersCount == 0

  created: ->
    if @load_users
      @loadUsersOptions()
    else
      @getUsersFromStore()



// WEBPACK FOOTER //
// ./src/mixins/users_options.coffee